import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';

import styles from './SectionWrapper.module.css';

type SectionBackground = 'navy' | 'soft' | 'white';

type SectionWrapperProps<T extends ElementType = 'section'> = {
  as?: T;
  background?: SectionBackground;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'children' | 'className'>;

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ');
}

export function SectionWrapper<T extends ElementType = 'section'>({
  as,
  background = 'white',
  children,
  className,
  contentClassName,
  ...rest
}: SectionWrapperProps<T>) {
  const Component = as ?? 'section';

  return (
    <Component
      className={classNames(styles.section, className)}
      data-background={background}
      {...rest}
    >
      <div className={classNames(styles.content, contentClassName)}>{children}</div>
    </Component>
  );
}
